export default "__VITE_PUBLIC_ASSET__c0f57e68__"